import { gql } from 'graphql-request'

export const CREATE_GAME_BOX_ROOM = gql`
  mutation CREATE_GAME_BOX_ROOM(
    $liveId: Int!
    $typeGameBoxLocal: TypeGameBoxLocal!
    $typeGameBoxSent: TypeGameBoxSent!
    $quantityPeopleEarning: Int!
    $valueTotalDistribute: Int!
    $timeForDistribute: Int!
    $message: String
  ) {
    createGameBoxRoom(
      liveId: $liveId
      typeGameBoxLocal: $typeGameBoxLocal
      typeGameBoxSent: $typeGameBoxSent
      quantityPeopleEarning: $quantityPeopleEarning
      valueTotalDistribute: $valueTotalDistribute
      timeForDistribute: $timeForDistribute
      message: $message
    ) {
      error
      status
      data {
        id
        liveId
        live {
          id
        }
        userId
        user {
          id
          username
        }
        typeGameBoxLocal
        typeGameBoxSent
        quantityPeopleEarning
        valueTotalDistribute
        timeForDistribute
        message
        quantityFollow
        dateSent
        createdAt
        updatedAt
        dateFinalDistribute
        dateInitialDistribute
        valueTotalEarning
      }
    }
  }
`

export const EARNING_GAME_BOX_ROOM = gql`
  mutation EARNING_GAME_BOX_ROOM($gameBoxRoomId: Int!) {
    earningGameBoxRoom(gameBoxRoomId: $gameBoxRoomId)
  }
`

export const UPDATE_GAME_BOX_ROOM = gql`
  mutation UPDATE_GAME_BOX_ROOM($gameBoxRoomId: Int!, $closed: Boolean) {
    updateGameBoxRoom(gameBoxRoomId: $gameBoxRoomId, closed: $closed) {
      error
      status
      data {
        id
        liveId
        live {
          id
        }
        userId
        user {
          id
          username
          imgUser
        }
        typeGameBoxLocal
        typeGameBoxSent
        quantityPeopleEarning
        valueTotalDistribute
        timeForDistribute
        message
        quantityFollow
        dateSent
        createdAt
        updatedAt
        dateFinalDistribute
        dateInitialDistribute
        valueTotalEarning
      }
    }
  }
`

export const GET_GAME_BOX_ROOM_EARNING = gql`
  query GET_GAME_BOX_ROOM_EARNING($gameBoxRoomId: Int) {
    getGameBoxRoomEarning(gameBoxRoomId: $gameBoxRoomId) {
      error
      status
      data {
        id
        gameBoxRoomId
        userId
        user {
          id
          username
        }
        createdAt
        updatedAt
        valueEarning
      }
    }
  }
`

export const GET_GAMES_BOXES_ROOMS = gql`
  query GET_GAMES_BOXES_ROOMS(
    $take: Int
    $skip: Int
    $userId: Int
    $liveId: Int
    $closed: Boolean
    $typeGameBoxLocal: TypeGameBoxLocal
    $typeGameBoxSent: TypeGameBoxSent
    $quantityPeopleEarning: Int
    $valueTotalDistribute: Int
    $timeForDistribute: Int
    $message: String
    $quantityFollow: Int
    $typeFilterDateDistribute: TypeFilter
    $dateInitialDistribute: String
    $dateFinalDistribute: String
    $valueTotalEarning: Int
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
  ) {
    getGamesBoxesRooms(
      take: $take
      skip: $skip
      userId: $userId
      liveId: $liveId
      closed: $closed
      typeGameBoxLocal: $typeGameBoxLocal
      typeGameBoxSent: $typeGameBoxSent
      quantityPeopleEarning: $quantityPeopleEarning
      valueTotalDistribute: $valueTotalDistribute
      timeForDistribute: $timeForDistribute
      message: $message
      quantityFollow: $quantityFollow
      typeFilterDateDistribute: $typeFilterDateDistribute
      dateInitialDistribute: $dateInitialDistribute
      dateFinalDistribute: $dateFinalDistribute
      valueTotalEarning: $valueTotalEarning
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      error
      status
      totalPages
      data {
        id
        liveId
        live {
          id
        }
        userId
        user {
          id
          username
          imgUser
        }
        typeGameBoxLocal
        typeGameBoxSent
        quantityPeopleEarning
        valueTotalDistribute
        timeForDistribute
        message
        quantityFollow
        dateSent
        createdAt
        updatedAt
        dateFinalDistribute
        dateInitialDistribute
        dateLimitToRescue
        valueTotalEarning
      }
    }
  }
`
